module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BaseWidget', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.areActionsRequired && !_vm.gettingActions),
      expression: "areActionsRequired && !gettingActions"
    }],
    attrs: {
      "no-footer": true
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("Forecasts")]), _vm._v(" "), _c('template', {
    slot: "content-desktop"
  }, [_c('RequiredActionsWidget', {
    attrs: {
      "show-spinner": false
    },
    on: {
      "areActionsRequired": function($event) {
        _vm.areActionsRequired = $event;
        _vm.gettingActions = false;
      }
    }
  })], 1), _vm._v(" "), _c('template', {
    slot: "content-mobile"
  }, [_c('RequiredActionsWidget', {
    attrs: {
      "show-spinner": false
    },
    on: {
      "areActionsRequired": function($event) {
        _vm.areActionsRequired = $event;
        _vm.gettingActions = false;
      }
    }
  })], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2390a024","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/widgets/ForecastWidget.vue
// module id = 3079
// module chunks = 0